import { render, staticRenderFns } from "./Canvan.vue?vue&type=template&id=3856e789&scoped=true"
import script from "./Canvan.vue?vue&type=script&lang=js"
export * from "./Canvan.vue?vue&type=script&lang=js"
import style0 from "./Canvan.vue?vue&type=style&index=0&id=3856e789&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856e789",
  null
  
)

export default component.exports